import { render, staticRenderFns } from "./HSCodesModule.vue?vue&type=template&id=54f78aa6&scoped=true"
import script from "./HSCodesModule.vue?vue&type=script&lang=js"
export * from "./HSCodesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f78aa6",
  null
  
)

export default component.exports